import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetExamsAuthorization,
	GetExamsAuthorizationModel,
	GetExamsAuthorizationParams,
} from 'domain/usecases';

export class RemoteGetExamsAuthorization implements GetExamsAuthorization {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetExamsAuthorizationModel>,
	) {}

	async get(params: GetExamsAuthorizationParams): Promise<GetExamsAuthorizationModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});

		if (httpResponse.status === HttpStatusCode.ok) {
			return {
				openAuthModal: false,
				authorized: true,
			};
		}
		return {
			openAuthModal: true,
			authorized: false,
		};
	}
}
